<template>
  <article class="component-content component-contact-card">
    <div class="entry">
      <section class="entry__header" >
        <div class="avatar" :style="{'background-color': avatarColor}">
          <span class="avatar__text">{{ avatarText }}</span>
        </div>
        <div class="text">
          <p class="title">{{ title }}</p>
          <p class="description">{{ role }}</p>
        </div>
      </section>
      <section v-if="email" class="entry__email">
        <p class="description" :id="`email-${id}`">{{ $t('contact.email') }}</p>
        <p class="content">
          <WrappedLink
            class="content__link"
            @click="emailClicked"
            external
            :href="'mailto:' + email"
            v-text="email"/>
        </p>
      </section>
      <section v-if="phone" class="entry__phone">
        <p class="description">{{ $t('contact.phone') }}</p>
        <p class="content">{{ phone }}</p>
      </section>
    </div>
  </article>
</template>
<script>

import eventTracker from '@/utils/eventTracker'
import WrappedLink from '@components/WrappedLink.vue'
export default {
  name: 'ContactCard',
  components: {
    WrappedLink
  },
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    role: {
      type: String,
      required: true
    },
    phone: {
      type: String
    },
    email: {
      type: String
    },
    avatarColor: {
      type: String
    },
    avatarText: {
      type: String,
      default: ''
    }
  },
  methods: {
    emailClicked () {
      eventTracker.track('ConnectHome Email', {
        Name: this.title
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .component-contact-card {
    .entry {
      width: 610px;
      border: 1px solid $mediumLightGrey;
      border-radius: 4px;
      padding: 32px 50px;
      &__header {
        display: flex;
        width: 100%;
        .avatar {
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background-color: $disabledBackground;
          display: flex;
          justify-content: center;
          align-items: center;
          &__text {
            color: $white;
            font-size: 24px;
            font-weight: bold;
            text-transform: uppercase;
          }
        }
        .text {
          margin-left: 40px;
          .title {
            margin: 0;
            font-size: 24px;
            font-weight: bold;
            color: $textColor;
          }
        }
      }
      &__email, &__phone {
        margin-top: 16px;
      }
      .content {
        margin: 0;
        font-family: $themeMainFont;
        font-size: 21px;
        font-weight: bold;
        color: $textColor;
        &__link {
          text-decoration: none;
          color: inherit;
        }
      }
      .description {
        margin: 0;
        font-family: $themeMainFont;
        font-size: 18px;
        font-weight: bold;
        color: $cyanGrey;
        text-transform: uppercase;
      }
    }
  }
</style>
